import { render, staticRenderFns } from "./Signer.vue?vue&type=template&id=05f851f3&scoped=true&"
import script from "./Signer.vue?vue&type=script&lang=js&"
export * from "./Signer.vue?vue&type=script&lang=js&"
import style0 from "./Signer.vue?vue&type=style&index=0&id=05f851f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f851f3",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f851f3')) {
      api.createRecord('05f851f3', component.options)
    } else {
      api.reload('05f851f3', component.options)
    }
    module.hot.accept("./Signer.vue?vue&type=template&id=05f851f3&scoped=true&", function () {
      api.rerender('05f851f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/Signer.vue"
export default component.exports